export default __webpack_public_path__ + "static/media/FAQ_HeroBanner.dd587921.png";